import { forwardRef } from 'react';
import { cn } from '../../helper/classNames';

const CardHeader = forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'flex flex-col space-y-1.5 p-6 pb-3 overflow-visible',
      className,
    )}
    {...props}
  />
));
CardHeader.displayName = 'CardHeader';

export { CardHeader };
